// Matches @audio-network/componentlibrary breakpoints.css (@custom-media --tablet/--desktop)
// Mobile is an explicit max-width so “no match” / stubbed false defaults to not-mobile (desktop-primary).
const MOBILE_QUERY = '(max-width: 47.9875em)'
const TABLET_QUERY = '(min-width: 48em)'
const DESKTOP_QUERY = '(min-width: 75em)'

type Breakpoint = 'mobile' | 'tablet' | 'desktop'

const isBreakpoint = (breakpoint: Breakpoint): boolean => {
	if (
		typeof window === 'undefined' ||
		typeof window.matchMedia !== 'function'
	) {
		return false
	}

	switch (breakpoint) {
		case 'mobile':
			return window.matchMedia(MOBILE_QUERY).matches
		case 'tablet':
			return (
				window.matchMedia(TABLET_QUERY).matches &&
				!window.matchMedia(DESKTOP_QUERY).matches
			)
		case 'desktop':
			return window.matchMedia(DESKTOP_QUERY).matches
	}
}

export default isBreakpoint
